import React, { useEffect, Fragment, useState, memo } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useDispatch, useSelector } from 'react-redux';
import { obtenerDatosLlaves } from "../../store/actions/caso-general-action";
import DatosGenerales from '../DatosGenerales';
import TabsComponent from './tabs';
import ImplicadoTerceros from '../implicadoTerceros';

import 'recupero-comunes/dist/index.css'
import HitosCaso from './hitos';
import ImplicadoTercerosDetalles from '../implicadoTerceroDetalles';


const CasoGeneral = memo(({idCaso,idImplicado, idOrganizacionCaso, detalles, setDatosCaso, reloadCaso }) => {

  const dispatch = useDispatch();
  
  useEffect(() => {   
    dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
     
    
  
  }, [dispatch])
  

  return (
    <>
    

      {detalles ?<HitosCaso/>: <DatosGenerales setDatosCaso = {setDatosCaso} reloadCaso={reloadCaso}/>}
       
           <TabsComponent/>
      {detalles ?<ImplicadoTercerosDetalles/>: <ImplicadoTerceros/>}
        
       
    </>
  )
})
export default CasoGeneral
